

// import React, { useEffect, useState, useCallback } from 'react';
// import { toast } from 'sonner';
// import { opsApi, apiError, fmtINR, GRAD, FONT_HEAD, ROLE_RANK } from './opsApi';
// import { Button } from '@/components/ui/button';
// import { Input } from '@/components/ui/input';
// import { Label } from '@/components/ui/label';
// import { Switch } from '@/components/ui/switch';
// import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
// import { Layers, Plus, Pencil, Trash2, Settings2, Package } from 'lucide-react';

// const EMPTY_TIER = { name: '', scope_path: '/india', min_accounts: 1, max_accounts: '', per_teacher_price: 0, per_student_price: 0, suggested_discount_pct: 0, active: true };
// const EMPTY_PLAN = { name: '', price_per_license: 0, license_limit: 0, active: true };

// export default function OpsPricing({ user }) {
//   const [tiers, setTiers] = useState([]);
//   const [plans, setPlans] = useState([]);
//   const [units, setUnits] = useState([]);
//   const [settings, setSettings] = useState(null);
//   const [editTier, setEditTier] = useState(null);
//   const [editPlan, setEditPlan] = useState(null);
//   const [busy, setBusy] = useState(false);
//   const rank = ROLE_RANK[user.role] || 0;

//   const load = useCallback(() => {
//     opsApi.get('/pricing-tiers').then((r) => setTiers(r.data)).catch(() => {});
//     opsApi.get('/plans').then((r) => setPlans(r.data)).catch(() => {});
//     opsApi.get('/org-units').then((r) => setUnits(r.data)).catch(() => {});
//     if (rank >= 4) opsApi.get('/settings').then((r) => setSettings(r.data)).catch(() => {});
//   }, [rank]);

//   useEffect(() => { load(); }, [load]);

//   const savePlan = async () => {
//     const p = editPlan.plan;
//     if (!p.name.trim()) { toast.error('Plan name required'); return; }
//     setBusy(true);
//     try {
//       const payload = {
//         name: p.name, price_per_license: Number(p.price_per_license),
//         license_limit: Number(p.license_limit), active: p.active,
//       };
//       if (editPlan.isNew) await opsApi.post('/plans', payload);
//       else await opsApi.put(`/plans/${p.id}`, payload);
//       toast.success('Plan saved');
//       setEditPlan(null);
//       load();
//     } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
//   };

//   const deactivatePlan = async (p) => {
//     try { await opsApi.delete(`/plans/${p.id}`); toast.success('Plan deactivated'); load(); }
//     catch (e) { toast.error(apiError(e)); }
//   };

//   const setP = (k) => (e) => setEditPlan((s) => ({ ...s, plan: { ...s.plan, [k]: e?.target ? e.target.value : e } }));

//   const saveTier = async () => {
//     const t = editTier.tier;
//     if (!t.name.trim()) { toast.error('Tier name required'); return; }
//     setBusy(true);
//     try {
//       const payload = {
//         name: t.name, scope_path: t.scope_path, min_accounts: Number(t.min_accounts),
//         max_accounts: t.max_accounts === '' || t.max_accounts === null ? null : Number(t.max_accounts),
//         per_teacher_price: Number(t.per_teacher_price), per_student_price: Number(t.per_student_price),
//         suggested_discount_pct: Number(t.suggested_discount_pct), active: t.active,
//       };
//       if (editTier.isNew) await opsApi.post('/pricing-tiers', payload);
//       else await opsApi.put(`/pricing-tiers/${t.id}`, payload);
//       toast.success('Tier saved');
//       setEditTier(null);
//       load();
//     } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
//   };

//   const deleteTier = async (t) => {
//     try { await opsApi.delete(`/pricing-tiers/${t.id}`); toast.success('Tier deleted'); load(); }
//     catch (e) { toast.error(apiError(e)); }
//   };

//   const saveSettings = async () => {
//     setBusy(true);
//     try {
//       await opsApi.put('/settings', {
//         onboarding_commission_flat: Number(settings.onboarding_commission_flat),
//         tax_pct: Number(settings.tax_pct),
//         default_billing_cycle: settings.default_billing_cycle,
//         default_rep_target_monthly: Number(settings.default_rep_target_monthly),
//         hub_storage_rate_per_gb: Number(settings.hub_storage_rate_per_gb),
//       });
//       toast.success('Settings saved');
//     } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
//   };

//   const setT = (k) => (e) => setEditTier((s) => ({ ...s, tier: { ...s.tier, [k]: e?.target ? e.target.value : e } }));
//   const grouped = tiers.reduce((acc, t) => { (acc[t.scope_path] = acc[t.scope_path] || []).push(t); return acc; }, {});

//   return (
//     <div className="space-y-8" data-testid="ops-pricing-page">
//       <div className="flex items-start justify-between gap-4 flex-wrap">
//         <div>
//           <h1 className="text-2xl md:text-3xl font-semibold tracking-tight" style={FONT_HEAD}>Pricing &amp; Settings</h1>
//           <p className="text-sm text-slate-500 mt-1">National pricing at /india with zone overrides. The deepest matching scope wins at billing time.</p>
//         </div>
//         <Button data-testid="add-tier-btn" onClick={() => setEditTier({ tier: { ...EMPTY_TIER, scope_path: rank >= 4 ? '/india' : user.scope_path }, isNew: true })}
//           className="text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
//           <Plus className="w-4 h-4 mr-1.5" /> New tier
//         </Button>
//       </div>

//       <div>
//         <div className="flex items-center justify-between mb-3">
//           <div>
//             <h2 className="text-base font-semibold" style={FONT_HEAD}>Fixed annual plans</h2>
//             <p className="text-xs text-slate-500 mt-0.5">Named plans institutions select at activation — fixed ₹/licence x licence limit, billed as one annual amount.</p>
//           </div>
//           <Button data-testid="add-plan-btn" onClick={() => setEditPlan({ plan: { ...EMPTY_PLAN }, isNew: true })}
//             variant="outline" className="rounded-xl h-9 border-slate-200">
//             <Plus className="w-4 h-4 mr-1.5" /> New plan
//           </Button>
//         </div>
//         <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
//           {plans.map((p) => (
//             <div key={p.id} data-testid={`plan-card-${p.name}`} className={`bg-white rounded-2xl border overflow-hidden ${p.active ? 'border-slate-200' : 'border-slate-100 opacity-50'}`}>
//               <div className="h-1" style={{ background: GRAD }} />
//               <div className="p-5">
//                 <div className="flex items-start justify-between mb-3">
//                   <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: GRAD }}>
//                     <Package className="w-4 h-4 text-white" />
//                   </div>
//                   <div className="flex gap-1">
//                     <button onClick={() => setEditPlan({ plan: { ...p }, isNew: false })} className="p-1.5 text-slate-300 hover:text-[#3B82F6]"><Pencil className="w-3.5 h-3.5" /></button>
//                     {rank >= 4 && <button onClick={() => deactivatePlan(p)} className="p-1.5 text-slate-300 hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>}
//                   </div>
//                 </div>
//                 <div className="text-base font-semibold" style={FONT_HEAD}>{p.name}</div>
//                 <div className="text-xs text-slate-400 mb-3">{p.license_limit.toLocaleString('en-IN')} licence limit</div>
//                 <div className="space-y-1.5 text-sm">
//                   <div className="flex justify-between"><span className="text-slate-500">Per licence</span><span className="font-medium tabular-nums">{fmtINR(p.price_per_license)}/yr</span></div>
//                   <div className="flex justify-between"><span className="text-slate-500">Total plan cost</span><span className="font-semibold tabular-nums">{fmtINR(p.price_per_license * p.license_limit)}/yr</span></div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {Object.entries(grouped).map(([scope, list]) => (
//         <div key={scope}>
//           <div className="text-xs font-mono text-[#3B82F6] mb-3">{scope} {scope === '/india' && <span className="text-slate-400 font-sans">· national pricing</span>}</div>
//           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
//             {list.map((t) => (
//               <div key={t.id} data-testid={`tier-card-${t.name}`} className={`bg-white rounded-2xl border overflow-hidden ${t.active ? 'border-slate-200' : 'border-slate-100 opacity-50'}`}>
//                 <div className="h-1" style={{ background: GRAD }} />
//                 <div className="p-5">
//                   <div className="flex items-start justify-between mb-3">
//                     <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: GRAD }}>
//                       <Layers className="w-4 h-4 text-white" />
//                     </div>
//                     <div className="flex gap-1">
//                       <button onClick={() => setEditTier({ tier: { ...t, max_accounts: t.max_accounts ?? '' }, isNew: false })} className="p-1.5 text-slate-300 hover:text-[#3B82F6]"><Pencil className="w-3.5 h-3.5" /></button>
//                       <button onClick={() => deleteTier(t)} className="p-1.5 text-slate-300 hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>
//                     </div>
//                   </div>
//                   <div className="text-base font-semibold" style={FONT_HEAD}>{t.name}</div>
//                   <div className="text-xs text-slate-400 mb-3">{t.min_accounts}–{t.max_accounts ?? '∞'} total accounts</div>
//                   <div className="space-y-1.5 text-sm">
//                     <div className="flex justify-between"><span className="text-slate-500">Teacher licence</span><span className="font-medium tabular-nums">{fmtINR(t.per_teacher_price)}/yr</span></div>
//                     <div className="flex justify-between"><span className="text-slate-500">Student licence</span><span className="font-medium tabular-nums">{fmtINR(t.per_student_price)}/yr</span></div>
//                     <div className="flex justify-between"><span className="text-slate-500">Suggested discount</span><span className="font-medium text-amber-600 tabular-nums">{t.suggested_discount_pct}%</span></div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       ))}

//       {settings && (
//         <div className="bg-white rounded-2xl border border-slate-200 p-6 max-w-3xl">
//           <h2 className="text-base font-semibold mb-5 flex items-center gap-2" style={FONT_HEAD}>
//             <Settings2 className="w-4 h-4 text-[#34A853]" /> Global settings
//           </h2>
//           <div className="grid sm:grid-cols-4 gap-4">
//             <div>
//               <Label className="text-xs">Onboarding commission (flat ₹)</Label>
//               <Input data-testid="settings-commission-input" type="number" min="0" value={settings.onboarding_commission_flat}
//                 onChange={(e) => setSettings((s) => ({ ...s, onboarding_commission_flat: e.target.value }))} className="mt-1" />
//             </div>
//             <div>
//               <Label className="text-xs">GST / Tax %</Label>
//               <Input data-testid="settings-tax-input" type="number" min="0" max="100" value={settings.tax_pct}
//                 onChange={(e) => setSettings((s) => ({ ...s, tax_pct: e.target.value }))} className="mt-1" />
//             </div>
//             <div>
//               <Label className="text-xs">Default rep target (₹/mo)</Label>
//               <Input data-testid="settings-target-input" type="number" min="0" value={settings.default_rep_target_monthly}
//                 onChange={(e) => setSettings((s) => ({ ...s, default_rep_target_monthly: e.target.value }))} className="mt-1" />
//             </div>
//             <div>
//               <Label className="text-xs">Default billing cycle</Label>
//               <select value={settings.default_billing_cycle}
//                 onChange={(e) => setSettings((s) => ({ ...s, default_billing_cycle: e.target.value }))}
//                 className="mt-1 w-full h-10 rounded-md border border-input bg-white px-3 text-sm">
//                 <option value="yearly">Yearly</option>
//                 <option value="monthly">Monthly</option>
//               </select>
//             </div>
//             <div>
//               <Label className="text-xs">DeskeyHUB storage rate (₹/GB-month)</Label>
//               <Input data-testid="settings-hub-rate-input" type="number" min="0" step="0.1" value={settings.hub_storage_rate_per_gb || 12}
//                 onChange={(e) => setSettings((s) => ({ ...s, hub_storage_rate_per_gb: e.target.value }))} className="mt-1" />
//             </div>
//           </div>
//           <Button data-testid="settings-save-btn" onClick={saveSettings} disabled={busy} className="mt-5 text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
//             {busy ? 'Saving…' : 'Save settings'}
//           </Button>
//         </div>
//       )}

//       <Dialog open={!!editTier} onOpenChange={(o) => !o && setEditTier(null)}>
//         <DialogContent className="max-w-md">
//           <DialogHeader>
//             <DialogTitle style={FONT_HEAD}>{editTier?.isNew ? 'New pricing tier' : `Edit ${editTier?.tier.name}`}</DialogTitle>
//             <DialogDescription>Prices are per licence per year (₹). Tier matched by an institution's total active accounts; deepest scope wins.</DialogDescription>
//           </DialogHeader>
//           {editTier && (
//             <div className="space-y-3">
//               <div className="grid grid-cols-2 gap-3">
//                 <div>
//                   <Label className="text-xs">Tier name *</Label>
//                   <Input data-testid="tier-name-input" value={editTier.tier.name} onChange={setT('name')} className="mt-1" />
//                 </div>
//                 <div>
//                   <Label className="text-xs">Scope</Label>
//                   <Select value={editTier.tier.scope_path} onValueChange={(v) => setEditTier((s) => ({ ...s, tier: { ...s.tier, scope_path: v } }))}>
//                     <SelectTrigger className="mt-1" data-testid="tier-scope-select"><SelectValue /></SelectTrigger>
//                     <SelectContent>
//                       {units.map((u) => <SelectItem key={u.path} value={u.path}>{u.path}</SelectItem>)}
//                     </SelectContent>
//                   </Select>
//                 </div>
//                 <div>
//                   <Label className="text-xs">Min accounts</Label>
//                   <Input type="number" min="1" value={editTier.tier.min_accounts} onChange={setT('min_accounts')} className="mt-1" />
//                 </div>
//                 <div>
//                   <Label className="text-xs">Max accounts (blank = ∞)</Label>
//                   <Input type="number" value={editTier.tier.max_accounts} onChange={setT('max_accounts')} className="mt-1" />
//                 </div>
//                 <div>
//                   <Label className="text-xs">₹ / teacher / year</Label>
//                   <Input data-testid="tier-teacher-price" type="number" min="0" value={editTier.tier.per_teacher_price} onChange={setT('per_teacher_price')} className="mt-1" />
//                 </div>
//                 <div>
//                   <Label className="text-xs">₹ / student / year</Label>
//                   <Input data-testid="tier-student-price" type="number" min="0" value={editTier.tier.per_student_price} onChange={setT('per_student_price')} className="mt-1" />
//                 </div>
//                 <div>
//                   <Label className="text-xs">Suggested discount %</Label>
//                   <Input type="number" min="0" max="100" value={editTier.tier.suggested_discount_pct} onChange={setT('suggested_discount_pct')} className="mt-1" />
//                 </div>
//                 <div className="flex items-center gap-2 pt-6">
//                   <Switch checked={editTier.tier.active} onCheckedChange={(v) => setEditTier((s) => ({ ...s, tier: { ...s.tier, active: v } }))} />
//                   <span className="text-sm text-slate-600">Active</span>
//                 </div>
//               </div>
//               <Button data-testid="tier-save-btn" onClick={saveTier} disabled={busy} className="w-full text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
//                 {busy ? 'Saving…' : 'Save tier'}
//               </Button>
//             </div>
//           )}
//         </DialogContent>
//       </Dialog>

//       <Dialog open={!!editPlan} onOpenChange={(o) => !o && setEditPlan(null)}>
//         <DialogContent className="max-w-md">
//           <DialogHeader>
//             <DialogTitle style={FONT_HEAD}>{editPlan?.isNew ? 'New plan' : `Edit ${editPlan?.plan.name}`}</DialogTitle>
//             <DialogDescription>Fixed annual price per licence x licence limit. Selected by sales/ops at institution activation.</DialogDescription>
//           </DialogHeader>
//           {editPlan && (
//             <div className="space-y-3">
//               <div className="grid grid-cols-2 gap-3">
//                 <div className="col-span-2">
//                   <Label className="text-xs">Plan name *</Label>
//                   <Input data-testid="plan-name-input" value={editPlan.plan.name} onChange={setP('name')} className="mt-1" />
//                 </div>
//                 <div>
//                   <Label className="text-xs">₹ / licence / year</Label>
//                   <Input data-testid="plan-price-input" type="number" min="0" value={editPlan.plan.price_per_license} onChange={setP('price_per_license')} className="mt-1" />
//                 </div>
//                 <div>
//                   <Label className="text-xs">Licence limit</Label>
//                   <Input data-testid="plan-limit-input" type="number" min="1" value={editPlan.plan.license_limit} onChange={setP('license_limit')} className="mt-1" />
//                 </div>
//                 <div className="col-span-2 flex items-center gap-2">
//                   <Switch checked={editPlan.plan.active} onCheckedChange={(v) => setEditPlan((s) => ({ ...s, plan: { ...s.plan, active: v } }))} />
//                   <span className="text-sm text-slate-600">Active</span>
//                 </div>
//               </div>
//               <div className="text-xs text-slate-500 bg-slate-50 rounded-lg p-3">
//                 Total annual plan cost: <span className="font-semibold tabular-nums">{fmtINR(Number(editPlan.plan.price_per_license || 0) * Number(editPlan.plan.license_limit || 0))}</span>
//               </div>
//               <Button data-testid="plan-save-btn" onClick={savePlan} disabled={busy} className="w-full text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
//                 {busy ? 'Saving…' : 'Save plan'}
//               </Button>
//             </div>
//           )}
//         </DialogContent>
//       </Dialog>
//     </div>
//   );
// }


import React, { useEffect, useState, useCallback } from 'react';
import { toast } from 'sonner';
import { opsApi, apiError, fmtINR, GRAD, FONT_HEAD, ROLE_RANK } from './opsApi';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Layers, Plus, Pencil, Trash2, Settings2, Package, HardDrive } from 'lucide-react';

const EMPTY_TIER = { name: '', scope_path: '/india', min_accounts: 1, max_accounts: '', per_teacher_price: 0, per_student_price: 0, suggested_discount_pct: 0, active: true };
const EMPTY_PLAN = { name: '', price_per_license: 0, license_limit: 0, active: true };
const EMPTY_HUB_PLAN = { name: '', quota_gb: 0, monthly_price: 0, active: true, order: 0 };

export default function OpsPricing({ user }) {
  const [tiers, setTiers] = useState([]);
  const [plans, setPlans] = useState([]);
  const [hubPlans, setHubPlans] = useState([]);
  const [units, setUnits] = useState([]);
  const [settings, setSettings] = useState(null);
  const [editTier, setEditTier] = useState(null);
  const [editPlan, setEditPlan] = useState(null);
  const [editHubPlan, setEditHubPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const rank = ROLE_RANK[user.role] || 0;

  const load = useCallback(() => {
    opsApi.get('/pricing-tiers').then((r) => setTiers(r.data)).catch(() => {});
    opsApi.get('/plans').then((r) => setPlans(r.data)).catch(() => {});
    opsApi.get('/storage/plans').then((r) => setHubPlans(r.data.plans || [])).catch(() => {});
    opsApi.get('/org-units').then((r) => setUnits(r.data)).catch(() => {});
    if (rank >= 4) opsApi.get('/settings').then((r) => setSettings(r.data)).catch(() => {});
  }, [rank]);

  useEffect(() => { load(); }, [load]);

  const saveHubPlan = async () => {
    const p = editHubPlan.plan;
    if (!p.name.trim()) { toast.error('Plan name required'); return; }
    setBusy(true);
    try {
      const payload = {
        name: p.name, quota_gb: Number(p.quota_gb), monthly_price: Number(p.monthly_price),
        active: p.active, order: Number(p.order) || 0,
      };
      if (editHubPlan.isNew) await opsApi.post('/storage/plans', payload);
      else await opsApi.put(`/storage/plans/${p.id}`, payload);
      toast.success('Storage plan saved');
      setEditHubPlan(null);
      load();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const deactivateHubPlan = async (p) => {
    try { await opsApi.delete(`/storage/plans/${p.id}`); toast.success('Storage plan deactivated'); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  const setHP = (k) => (e) => setEditHubPlan((s) => ({ ...s, plan: { ...s.plan, [k]: e?.target ? e.target.value : e } }));

  const savePlan = async () => {
    const p = editPlan.plan;
    if (!p.name.trim()) { toast.error('Plan name required'); return; }
    setBusy(true);
    try {
      const payload = {
        name: p.name, price_per_license: Number(p.price_per_license),
        license_limit: Number(p.license_limit), active: p.active,
      };
      if (editPlan.isNew) await opsApi.post('/plans', payload);
      else await opsApi.put(`/plans/${p.id}`, payload);
      toast.success('Plan saved');
      setEditPlan(null);
      load();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const deactivatePlan = async (p) => {
    try { await opsApi.delete(`/plans/${p.id}`); toast.success('Plan deactivated'); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  const setP = (k) => (e) => setEditPlan((s) => ({ ...s, plan: { ...s.plan, [k]: e?.target ? e.target.value : e } }));

  const saveTier = async () => {
    const t = editTier.tier;
    if (!t.name.trim()) { toast.error('Tier name required'); return; }
    setBusy(true);
    try {
      const payload = {
        name: t.name, scope_path: t.scope_path, min_accounts: Number(t.min_accounts),
        max_accounts: t.max_accounts === '' || t.max_accounts === null ? null : Number(t.max_accounts),
        per_teacher_price: Number(t.per_teacher_price), per_student_price: Number(t.per_student_price),
        suggested_discount_pct: Number(t.suggested_discount_pct), active: t.active,
      };
      if (editTier.isNew) await opsApi.post('/pricing-tiers', payload);
      else await opsApi.put(`/pricing-tiers/${t.id}`, payload);
      toast.success('Tier saved');
      setEditTier(null);
      load();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const deleteTier = async (t) => {
    try { await opsApi.delete(`/pricing-tiers/${t.id}`); toast.success('Tier deleted'); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  const saveSettings = async () => {
    setBusy(true);
    try {
      await opsApi.put('/settings', {
        onboarding_commission_flat: Number(settings.onboarding_commission_flat),
        tax_pct: Number(settings.tax_pct),
        default_billing_cycle: settings.default_billing_cycle,
        default_rep_target_monthly: Number(settings.default_rep_target_monthly),
        hub_storage_rate_per_gb: Number(settings.hub_storage_rate_per_gb),
      });
      toast.success('Settings saved');
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  const setT = (k) => (e) => setEditTier((s) => ({ ...s, tier: { ...s.tier, [k]: e?.target ? e.target.value : e } }));
  const grouped = tiers.reduce((acc, t) => { (acc[t.scope_path] = acc[t.scope_path] || []).push(t); return acc; }, {});

  return (
    <div className="space-y-8" data-testid="ops-pricing-page">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-2xl md:text-3xl font-semibold tracking-tight" style={FONT_HEAD}>Pricing &amp; Settings</h1>
          <p className="text-sm text-slate-500 mt-1">National pricing at /india with zone overrides. The deepest matching scope wins at billing time.</p>
        </div>
        <Button data-testid="add-tier-btn" onClick={() => setEditTier({ tier: { ...EMPTY_TIER, scope_path: rank >= 4 ? '/india' : user.scope_path }, isNew: true })}
          className="text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
          <Plus className="w-4 h-4 mr-1.5" /> New tier
        </Button>
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <div>
            <h2 className="text-base font-semibold" style={FONT_HEAD}>Fixed annual plans</h2>
            <p className="text-xs text-slate-500 mt-0.5">Named plans institutions select at activation — fixed ₹/licence x licence limit, billed as one annual amount.</p>
          </div>
          <Button data-testid="add-plan-btn" onClick={() => setEditPlan({ plan: { ...EMPTY_PLAN }, isNew: true })}
            variant="outline" className="rounded-xl h-9 border-slate-200">
            <Plus className="w-4 h-4 mr-1.5" /> New plan
          </Button>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {plans.map((p) => (
            <div key={p.id} data-testid={`plan-card-${p.name}`} className={`bg-white rounded-2xl border overflow-hidden ${p.active ? 'border-slate-200' : 'border-slate-100 opacity-50'}`}>
              <div className="h-1" style={{ background: GRAD }} />
              <div className="p-5">
                <div className="flex items-start justify-between mb-3">
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: GRAD }}>
                    <Package className="w-4 h-4 text-white" />
                  </div>
                  <div className="flex gap-1">
                    <button onClick={() => setEditPlan({ plan: { ...p }, isNew: false })} className="p-1.5 text-slate-300 hover:text-[#3B82F6]"><Pencil className="w-3.5 h-3.5" /></button>
                    {rank >= 4 && <button onClick={() => deactivatePlan(p)} className="p-1.5 text-slate-300 hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>}
                  </div>
                </div>
                <div className="text-base font-semibold" style={FONT_HEAD}>{p.name}</div>
                <div className="text-xs text-slate-400 mb-3">{p.license_limit.toLocaleString('en-IN')} licence limit</div>
                <div className="space-y-1.5 text-sm">
                  <div className="flex justify-between"><span className="text-slate-500">Per licence</span><span className="font-medium tabular-nums">{fmtINR(p.price_per_license)}/yr</span></div>
                  <div className="flex justify-between"><span className="text-slate-500">Total plan cost</span><span className="font-semibold tabular-nums">{fmtINR(p.price_per_license * p.license_limit)}/yr</span></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between mb-3">
          <div>
            <h2 className="text-base font-semibold" style={FONT_HEAD}>DeskeyHUB storage plans</h2>
            <p className="text-xs text-slate-500 mt-0.5">Free 20GB baseline, plus fixed monthly tiers institutions can switch between — billed annually alongside licences.</p>
          </div>
          <Button data-testid="add-hub-plan-btn" onClick={() => setEditHubPlan({ plan: { ...EMPTY_HUB_PLAN, order: hubPlans.length + 1 }, isNew: true })}
            variant="outline" className="rounded-xl h-9 border-slate-200">
            <Plus className="w-4 h-4 mr-1.5" /> New storage plan
          </Button>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {hubPlans.map((p) => (
            <div key={p.id} data-testid={`hub-plan-card-${p.name}`} className={`bg-white rounded-2xl border overflow-hidden ${p.active ? 'border-slate-200' : 'border-slate-100 opacity-50'}`}>
              <div className="h-1" style={{ background: GRAD }} />
              <div className="p-5">
                <div className="flex items-start justify-between mb-3">
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: GRAD }}>
                    <HardDrive className="w-4 h-4 text-white" />
                  </div>
                  <div className="flex gap-1">
                    <button onClick={() => setEditHubPlan({ plan: { ...p }, isNew: false })} className="p-1.5 text-slate-300 hover:text-[#3B82F6]"><Pencil className="w-3.5 h-3.5" /></button>
                    {rank >= 4 && <button onClick={() => deactivateHubPlan(p)} className="p-1.5 text-slate-300 hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>}
                  </div>
                </div>
                <div className="text-base font-semibold" style={FONT_HEAD}>{p.name}</div>
                <div className="text-xs text-slate-400 mb-3">{p.quota_gb.toLocaleString('en-IN')} GB quota</div>
                <div className="space-y-1.5 text-sm">
                  <div className="flex justify-between"><span className="text-slate-500">Monthly price</span><span className="font-semibold tabular-nums">{fmtINR(p.monthly_price)}/mo</span></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {Object.entries(grouped).map(([scope, list]) => (
        <div key={scope}>
          <div className="text-xs font-mono text-[#3B82F6] mb-3">{scope} {scope === '/india' && <span className="text-slate-400 font-sans">· national pricing</span>}</div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {list.map((t) => (
              <div key={t.id} data-testid={`tier-card-${t.name}`} className={`bg-white rounded-2xl border overflow-hidden ${t.active ? 'border-slate-200' : 'border-slate-100 opacity-50'}`}>
                <div className="h-1" style={{ background: GRAD }} />
                <div className="p-5">
                  <div className="flex items-start justify-between mb-3">
                    <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: GRAD }}>
                      <Layers className="w-4 h-4 text-white" />
                    </div>
                    <div className="flex gap-1">
                      <button onClick={() => setEditTier({ tier: { ...t, max_accounts: t.max_accounts ?? '' }, isNew: false })} className="p-1.5 text-slate-300 hover:text-[#3B82F6]"><Pencil className="w-3.5 h-3.5" /></button>
                      <button onClick={() => deleteTier(t)} className="p-1.5 text-slate-300 hover:text-red-500"><Trash2 className="w-3.5 h-3.5" /></button>
                    </div>
                  </div>
                  <div className="text-base font-semibold" style={FONT_HEAD}>{t.name}</div>
                  <div className="text-xs text-slate-400 mb-3">{t.min_accounts}–{t.max_accounts ?? '∞'} total accounts</div>
                  <div className="space-y-1.5 text-sm">
                    <div className="flex justify-between"><span className="text-slate-500">Teacher licence</span><span className="font-medium tabular-nums">{fmtINR(t.per_teacher_price)}/yr</span></div>
                    <div className="flex justify-between"><span className="text-slate-500">Student licence</span><span className="font-medium tabular-nums">{fmtINR(t.per_student_price)}/yr</span></div>
                    <div className="flex justify-between"><span className="text-slate-500">Suggested discount</span><span className="font-medium text-amber-600 tabular-nums">{t.suggested_discount_pct}%</span></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {settings && (
        <div className="bg-white rounded-2xl border border-slate-200 p-6 max-w-3xl">
          <h2 className="text-base font-semibold mb-5 flex items-center gap-2" style={FONT_HEAD}>
            <Settings2 className="w-4 h-4 text-[#34A853]" /> Global settings
          </h2>
          <div className="grid sm:grid-cols-4 gap-4">
            <div>
              <Label className="text-xs">Onboarding commission (flat ₹)</Label>
              <Input data-testid="settings-commission-input" type="number" min="0" value={settings.onboarding_commission_flat}
                onChange={(e) => setSettings((s) => ({ ...s, onboarding_commission_flat: e.target.value }))} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs">GST / Tax %</Label>
              <Input data-testid="settings-tax-input" type="number" min="0" max="100" value={settings.tax_pct}
                onChange={(e) => setSettings((s) => ({ ...s, tax_pct: e.target.value }))} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs">Default rep target (₹/mo)</Label>
              <Input data-testid="settings-target-input" type="number" min="0" value={settings.default_rep_target_monthly}
                onChange={(e) => setSettings((s) => ({ ...s, default_rep_target_monthly: e.target.value }))} className="mt-1" />
            </div>
            <div>
              <Label className="text-xs">Default billing cycle</Label>
              <select value={settings.default_billing_cycle}
                onChange={(e) => setSettings((s) => ({ ...s, default_billing_cycle: e.target.value }))}
                className="mt-1 w-full h-10 rounded-md border border-input bg-white px-3 text-sm">
                <option value="yearly">Yearly</option>
                <option value="monthly">Monthly</option>
              </select>
            </div>
            <div>
              <Label className="text-xs">DeskeyHUB storage rate (₹/GB-month)</Label>
              <Input data-testid="settings-hub-rate-input" type="number" min="0" step="0.1" value={settings.hub_storage_rate_per_gb || 12}
                onChange={(e) => setSettings((s) => ({ ...s, hub_storage_rate_per_gb: e.target.value }))} className="mt-1" />
            </div>
          </div>
          <Button data-testid="settings-save-btn" onClick={saveSettings} disabled={busy} className="mt-5 text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
            {busy ? 'Saving…' : 'Save settings'}
          </Button>
        </div>
      )}

      <Dialog open={!!editTier} onOpenChange={(o) => !o && setEditTier(null)}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle style={FONT_HEAD}>{editTier?.isNew ? 'New pricing tier' : `Edit ${editTier?.tier.name}`}</DialogTitle>
            <DialogDescription>Prices are per licence per year (₹). Tier matched by an institution's total active accounts; deepest scope wins.</DialogDescription>
          </DialogHeader>
          {editTier && (
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label className="text-xs">Tier name *</Label>
                  <Input data-testid="tier-name-input" value={editTier.tier.name} onChange={setT('name')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">Scope</Label>
                  <Select value={editTier.tier.scope_path} onValueChange={(v) => setEditTier((s) => ({ ...s, tier: { ...s.tier, scope_path: v } }))}>
                    <SelectTrigger className="mt-1" data-testid="tier-scope-select"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {units.map((u) => <SelectItem key={u.path} value={u.path}>{u.path}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label className="text-xs">Min accounts</Label>
                  <Input type="number" min="1" value={editTier.tier.min_accounts} onChange={setT('min_accounts')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">Max accounts (blank = ∞)</Label>
                  <Input type="number" value={editTier.tier.max_accounts} onChange={setT('max_accounts')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">₹ / teacher / year</Label>
                  <Input data-testid="tier-teacher-price" type="number" min="0" value={editTier.tier.per_teacher_price} onChange={setT('per_teacher_price')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">₹ / student / year</Label>
                  <Input data-testid="tier-student-price" type="number" min="0" value={editTier.tier.per_student_price} onChange={setT('per_student_price')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">Suggested discount %</Label>
                  <Input type="number" min="0" max="100" value={editTier.tier.suggested_discount_pct} onChange={setT('suggested_discount_pct')} className="mt-1" />
                </div>
                <div className="flex items-center gap-2 pt-6">
                  <Switch checked={editTier.tier.active} onCheckedChange={(v) => setEditTier((s) => ({ ...s, tier: { ...s.tier, active: v } }))} />
                  <span className="text-sm text-slate-600">Active</span>
                </div>
              </div>
              <Button data-testid="tier-save-btn" onClick={saveTier} disabled={busy} className="w-full text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
                {busy ? 'Saving…' : 'Save tier'}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={!!editPlan} onOpenChange={(o) => !o && setEditPlan(null)}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle style={FONT_HEAD}>{editPlan?.isNew ? 'New plan' : `Edit ${editPlan?.plan.name}`}</DialogTitle>
            <DialogDescription>Fixed annual price per licence x licence limit. Selected by sales/ops at institution activation.</DialogDescription>
          </DialogHeader>
          {editPlan && (
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div className="col-span-2">
                  <Label className="text-xs">Plan name *</Label>
                  <Input data-testid="plan-name-input" value={editPlan.plan.name} onChange={setP('name')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">₹ / licence / year</Label>
                  <Input data-testid="plan-price-input" type="number" min="0" value={editPlan.plan.price_per_license} onChange={setP('price_per_license')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">Licence limit</Label>
                  <Input data-testid="plan-limit-input" type="number" min="1" value={editPlan.plan.license_limit} onChange={setP('license_limit')} className="mt-1" />
                </div>
                <div className="col-span-2 flex items-center gap-2">
                  <Switch checked={editPlan.plan.active} onCheckedChange={(v) => setEditPlan((s) => ({ ...s, plan: { ...s.plan, active: v } }))} />
                  <span className="text-sm text-slate-600">Active</span>
                </div>
              </div>
              <div className="text-xs text-slate-500 bg-slate-50 rounded-lg p-3">
                Total annual plan cost: <span className="font-semibold tabular-nums">{fmtINR(Number(editPlan.plan.price_per_license || 0) * Number(editPlan.plan.license_limit || 0))}</span>
              </div>
              <Button data-testid="plan-save-btn" onClick={savePlan} disabled={busy} className="w-full text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
                {busy ? 'Saving…' : 'Save plan'}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      <Dialog open={!!editHubPlan} onOpenChange={(o) => !o && setEditHubPlan(null)}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle style={FONT_HEAD}>{editHubPlan?.isNew ? 'New storage plan' : `Edit ${editHubPlan?.plan.name}`}</DialogTitle>
            <DialogDescription>Fixed monthly price for a storage quota. Institutions switch plans from Invoices → Storage.</DialogDescription>
          </DialogHeader>
          {editHubPlan && (
            <div className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <div className="col-span-2">
                  <Label className="text-xs">Plan name *</Label>
                  <Input data-testid="hub-plan-name-input" value={editHubPlan.plan.name} onChange={setHP('name')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">Quota (GB)</Label>
                  <Input data-testid="hub-plan-quota-input" type="number" min="1" value={editHubPlan.plan.quota_gb} onChange={setHP('quota_gb')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">₹ / month</Label>
                  <Input data-testid="hub-plan-price-input" type="number" min="0" value={editHubPlan.plan.monthly_price} onChange={setHP('monthly_price')} className="mt-1" />
                </div>
                <div>
                  <Label className="text-xs">Sort order</Label>
                  <Input type="number" min="0" value={editHubPlan.plan.order} onChange={setHP('order')} className="mt-1" />
                </div>
                <div className="flex items-center gap-2 pt-6">
                  <Switch checked={editHubPlan.plan.active} onCheckedChange={(v) => setEditHubPlan((s) => ({ ...s, plan: { ...s.plan, active: v } }))} />
                  <span className="text-sm text-slate-600">Active</span>
                </div>
              </div>
              <Button data-testid="hub-plan-save-btn" onClick={saveHubPlan} disabled={busy} className="w-full text-white rounded-xl h-10 border-0" style={{ background: GRAD }}>
                {busy ? 'Saving…' : 'Save storage plan'}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
